<template>
<div class="mt-3 py-5">
	<b-container class="px-3 p-md-0">
		<b-row>
			<b-col cols="12" md="8" class="m-auto px-3">

        <div class="container">

					<div class="row justify-content-center pt-2 pb-5">

              <nav class="pankuzu w-100">
                <ul class="my-4">
                  <li><img class="" src="/static/img/icon/pankuzu.png" style="height: 17px;padding-bottom: 3px;"><a @click="jump(0)">  ピアチュウ TOP</a></li>
                  <li>  ピアチュウで禁止されている行為について</li>
                </ul>
              </nav>

              <div class="card">
                <div class="card-header text-center">ピアチュウで禁止されている行為について</div>
                <div class="card-body">
                  <p>ピアチュウをご利用いただきまして誠にありがとうございます。 下記の行為は、いずれも違反行為となりますのでご注意ください。継続して不正行為を行っている利用者（ユーザー）およびピアノ販売事業者につきましては、利用停止となる場合があります。 </p>
                  <h2>ピアチュウを回避して個別にピアノや付属品等を購入する行為</h2>
                  <ul>
                    <p>ピアチュウ以外の手段によって、ユーザーとピアノ販売事業者が直接取引する行為は利用規約違反となります。</p>
                    <li>例：ユーザーが試弾申し込みを経て実際に試弾を終えた際に、ピアチュウでピアノ購入申し込みをせずに、申し込み者と販売事業者が個別に購入契約を交わす（直接取引をする）行為</li>
                    <li>例：ユーザーがピアチュウの販売事業者ページや販売ページからお問い合わせをしたり試弾申し込み後、メッセージや電話にて直接取引を促す行為</li>
                    <li>例：外部サイトへの申し込みを促す行為</li>
                  </ul>
                  <h2>自社サイトなどに誘導する行為</h2>
                  <ul>
                    <p>ピアチュウでの購入申し込みを目的とせず、販売事業者が自社などの外部サイトへ誘導する行為は利用規約違反となります。</p>
                    <li>例：ユーザーからのお問い合わせや試弾申し込み後に、販売事業者がメッセージでピアチュウ以外の商品を紹介し、外部サイトへの申し込みや問い合わせを促す行為</li>
                    <li>例：ピアチュウの販売事業者ページ及びユーザーとのやり取りメッセージにおいて、申し込みへの動線となる外部サイトURLを載せる行為</li>
                    <li>例：販売事業者ページに、メールアドレス、SNSなどのID、電話番号を記載する行為</li>
                    <li>例：販売事業者ページの画像にQRコードを示し、外部のサイトへ誘導する行為</li>
                    <li>例：販売事業者が販売ページに掲載する動画（Youtubeなど）を使って、動画内にて自社の宣伝を行ったり、外部サイトへ誘導する行為</li>
                  </ul>
                  <h2>不正に実績を作る行為</h2>
                  <ul>
                    <p>ユーザーになりすまし、大量に口コミレビューを投稿することで不正に実績を作る行為は利用規約違反となります。</p>
                  </ul>
                  <h2>他サービスや商品の宣伝行為</h2>
                  <ul>
                    <p>商品販売ページの中で、ピアノに直接関連のないサービスや商品の宣伝や商品の購入をうながす行為は利用規約違反となります。</p>
                  </ul>
                  <br>
                  <p>安心で公平な運営のため、ご理解のほどよろしくお願いいたします。また、上記に該当するような違反行為を発見されましたら、運営事務局までお知らせください。 
                    <br>
                    <a href="https://www.piachu.net/contact">お知らせはこちらから</a>
                  </p>
                  <p class="tR">以上</p>
                </div>
              </div>

					</div>

        </div>

			</b-col>
		</b-row>
	</b-container>
</div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'ProhibitedActs',
  data() {
    return {
    }
  },
  methods: {
    jump(number) {
      if (number==0) {
        this.$router.push({path: '/'});
      }
    },
  },
	computed: {
	},
  created() {
  },
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/ProhibitedActs.vue